import { render } from "./servicemain.vue?vue&type=template&id=1441ece2&scoped=true"
const script = {}

import "./servicemain.vue?vue&type=style&index=0&id=1441ece2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1441ece2"]])

export default __exports__